import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import {
  Box,
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Divider,
  IconButton,
  Tooltip,
  TextField,
  List, 
  ListItem, 
  ListItemIcon,
  ListItemText,
  CssBaseline,
  Drawer,
  InputAdornment,
  Button,
  useTheme,
  styled,
  useMediaQuery,
  Collapse,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  ListItemButton,
  Link,
  Menu,
  MenuItem,
  Card,
  CardContent,
  Stack
} from '@mui/material';
import {
  Layers,
  ExpandLess,
  InsertDriveFile,
  Description,
  MoreVert,
  Search,
  FileCopy,
  Download,
  Share,
  Home,
  Nature,
  Menu as MenuIcon,
  School,
  Close,
  FamilyRestroom,
  Man,
  TrendingUp,
  Public,
  ExpandMore,
  Email,
  WhatsApp,
  Bluetooth,
  Groups,
  LocalHospital,
  Person,
  Grass,
  Spa,
  BugReport,
  Hive,
  Water as WaterIcon,
  Groups3,
  Handshake,
  Diversity3,
  House,
  Roofing,
  Map,
  Pets as LivestockIcon,
  EggAlt as PoultryIcon,
  Cottage as EmergencyHomeIcon, 
  AccessibilityNew, 
  ChildCare, 
  Terrain, 
  PictureAsPdf,
  Engineering 
} from '@mui/icons-material';

// Constantes de style
const drawerWidth = 240;
const primaryColor = '#E30613';
const secondaryColor = '#008D36';
const backgroundColor = '#f5f5f5';

// Composants stylisés
const MainContainer = styled('div')({
  display: 'flex',
  backgroundColor: backgroundColor,
  minHeight: '100vh',
  flexDirection: 'column'
});

const MainContentWithDrawer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  marginTop: '64px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '56px'
  }
}));

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  padding: theme.spacing(2),
  backgroundColor: backgroundColor,
  height: 'calc(100vh - 64px)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    height: 'calc(100vh - 56px)'
  }
}));

const DrawerWrapper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(-100%)',
    },
  }
}));

const MobileDrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const StyledTableHead = styled(TableHead)({
  backgroundColor: primaryColor,
  '& th': {
    color: 'white',
    fontWeight: 'bold'
  }
});

const ProvinceRow = styled(TableRow)({
  backgroundColor: '#e0e0e0',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#d0d0d0 !important'
  }
});

const CommuneRow = styled(TableRow)({
  '&:hover': {
    backgroundColor: '#f5f5f5 !important'
  }
});

const menuItems = [
  { text: 'Ménages par type', icon: <FamilyRestroom color="primary" />, to: '/RGPHAEDataPage' },
  { text: 'Population par localisation', icon: <Public color="primary" />, to: '/PopulationDataPage' },
  { text: 'Ménages collectifs', icon: <Groups color="primary" />, to: '/PopulationCollectiveHouseholdsPage' },
  { text: 'Sans-abris', icon: <EmergencyHomeIcon color="primary" />, to: '/HomelessPopulationPage' },
  { text: 'Ménages ordinaires', icon: <Home color="primary" />, to: '/PopulationResidentPage' },
  { text: 'Sexe et masculinité', icon: <Man color="primary" />, to: '/PopulationDataPageM' },
  { text: 'Rapport de masculinité', icon: <TrendingUp color="primary" />, to: '/MasculinityRatioPage' },
  { text: 'Population par âge', icon: <ChildCare color="primary" />, to: '/PopulationDataPageAge' },
  { text: "Grands groupes d'âge", icon: <AccessibilityNew color="primary" />, to: '/PopulationAgeGroupPageGrand' },
  { text: "Groupes d'âge (éducation)", icon: <School color="primary" />, to: '/PopulationByAgeGroupPage' },
  { text: 'Groupes d\'âge (santé)', icon: <LocalHospital color="primary" />, to: '/AgeGroupPopulationPage' },
  { text: 'Adultes (18+)', icon: <Person color="primary" />, to: '/AdultPopulationPage' },
  
  // Agriculture
  { text: 'Ménages agricoles', icon: <Nature color="primary" />, to: '/AgriculturalHouseholdsPage' },
  { text: 'Pratiques agricoles', icon: <Grass color="primary" />, to: '/AgriculturalHouseholdsPages' },
  { text: 'Types de cultures', icon: <Spa color="primary" />, to: '/AgriculturalHouseholdsPage20' },
  
  // Élevage
  { text: 'Élevage par espèces', icon: <LivestockIcon color="primary" />, to: '/FarmingHouseholdsPage' },
  { text: 'Élevage de volailles', icon: <PoultryIcon color="primary" />, to: '/poultryFarmingPage' },
  { text: 'Élevage spécial', icon: <BugReport color="primary" />, to: '/insectFarmingHouseholdsPage' },
  { text: 'Répartition cheptel', icon: <LivestockIcon color="primary" />, to: '/livestockDistributionPage' },
  { text: 'Répartition volailles', icon: <PoultryIcon color="primary" />, to: '/poultryDistributionPage' },
  
  // Matériel agricole
  { text: 'Équipements agricoles', icon: <Engineering color="primary" />, to: '/agriculturalEquipmentPage' },
  { text: 'Apiculture', icon: <Hive color="primary" />, to: '/beekeepingHouseholdsPage' },
  { text: 'Pêche/aquaculture', icon: <WaterIcon color="primary" />, to: '/fishingHouseholdsPage' },
  
  // Associations
  { text: 'Interventions associations', icon: <Groups3 color="primary" />, to: '/associationInterventionPage' },
  { text: 'Interventions coopératives', icon: <Handshake color="primary" />, to: '/cooperativeInterventionPage' },
  { text: 'Interventions ONG', icon: <Diversity3 color="primary" />, to: '/interventionProjectsPage' },
  
  // Habitat
  { text: "Type d'habitat", icon: <House color="primary" />, to: '/housingDistributionPage' },
  { text: 'Matériau toit', icon: <Roofing color="primary" />, to: '/roofMaterialPage' },
  { text: 'Matériau sol', icon: <Layers color="primary" />, to: '/housingMaterialPage' },
  { text: 'Ménages agricoles', icon: <Terrain color="primary" />, to: '/agriculturalHouseholdsPageProvCom' },
  { text: 'Population par âge/résidence', icon: <Map color="primary" />, to: '/populationAgeResidencePage' },
];

// Structure des données hiérarchisées
const homelessData = {
  title: "Répartition de la population des sans-abris par province et commune selon le sexe",
  provinces: [
    {
      name: "BUHUMUZA",
      communes: [
        { name: "BUTAGANZWA", masculin: "0", feminin: "0", total: "0", proportion: "0" },
        { name: "BUTIHINDA", masculin: "43", feminin: "1", total: "44", proportion: "2" },
        { name: "CANKUZO", masculin: "3", feminin: "0", total: "3", proportion: "0,1" },
        { name: "GISAGARA", masculin: "0", feminin: "1", total: "1", proportion: "0" },
        { name: "GISURU", masculin: "1", feminin: "1", total: "2", proportion: "0,1" },
        { name: "MUYINGA", masculin: "61", feminin: "1", total: "62", proportion: "2,8" },
        { name: "RUYIGI", masculin: "2", feminin: "1", total: "3", proportion: "0,1" }
      ],
      masculin: "110",
      feminin: "5",
      total: "115",
      proportion: "5,1"
    },
    {
      name: "BUJUMBURA",
      communes: [
        { name: "BUBANZA", masculin: "20", feminin: "2", total: "22", proportion: "1" },
        { name: "BUKINANYANA", masculin: "0", feminin: "0", total: "0", proportion: "0" },
        { name: "CIBITOKE", masculin: "26", feminin: "1", total: "27", proportion: "1,2" },
        { name: "ISARE", masculin: "1", feminin: "0", total: "1", proportion: "0" },
        { name: "MPANDA", masculin: "57", feminin: "9", total: "66", proportion: "2,9" },
        { name: "MUGERE", masculin: "97", feminin: "7", total: "104", proportion: "4,6" },
        { name: "MUGINA", masculin: "16", feminin: "1", total: "17", proportion: "0,8" },
        { name: "MUHUTA", masculin: "1", feminin: "0", total: "1", proportion: "0" },
        { name: "MUKAZA", masculin: "635", feminin: "57", total: "692", proportion: "30,7" },
        { name: "NTAHANGWA", masculin: "553", feminin: "93", total: "646", proportion: "28,7" },
        { name: "RWIBAGA", masculin: "0", feminin: "0", total: "0", proportion: "0" }
      ],
      masculin: "1 406",
      feminin: "170",
      total: "1 576",
      proportion: "70,0"
    },
    {
      name: "BURUNGA",
      communes: [
        { name: "BURURI", masculin: "0", feminin: "2", total: "2", proportion: "0,1" },
        { name: "MAKAMBA", masculin: "8", feminin: "0", total: "8", proportion: "0,4" },
        { name: "MATANA", masculin: "0", feminin: "0", total: "0", proportion: "0" },
        { name: "MUSONGATI", masculin: "2", feminin: "4", total: "6", proportion: "0,3" },
        { name: "NYANZA", masculin: "8", feminin: "3", total: "11", proportion: "0,5" },
        { name: "RUMONGE", masculin: "29", feminin: "9", total: "38", proportion: "1,7" },
        { name: "RUTANA", masculin: "4", feminin: "0", total: "4", proportion: "0,2" }
      ],
      masculin: "51",
      feminin: "18",
      total: "69",
      proportion: "3,1"
    },
    {
      name: "BUTANYERERA",
      communes: [
        { name: "BUSONI", masculin: "45", feminin: "1", total: "46", proportion: "2" },
        { name: "KAYANZA", masculin: "38", feminin: "2", total: "40", proportion: "1,8" },
        { name: "KIREMBA", masculin: "33", feminin: "0", total: "33", proportion: "1,5" },
        { name: "KIRUNDO", masculin: "142", feminin: "14", total: "156", proportion: "6,9" },
        { name: "MATONGO", masculin: "5", feminin: "2", total: "7", proportion: "0,3" },
        { name: "MUHANGA", masculin: "8", feminin: "0", total: "8", proportion: "0,4" },
        { name: "NGOZI", masculin: "87", feminin: "3", total: "90", proportion: "4" },
        { name: "TANGARA", masculin: "16", feminin: "4", total: "20", proportion: "0,9" }
      ],
      masculin: "374",
      feminin: "26",
      total: "400",
      proportion: "17,8"
    },
    {
      name: "GITEGA",
      communes: [
        { name: "BUGENDANA", masculin: "0", feminin: "0", total: "0", proportion: "0" },
        { name: "GISHUBI", masculin: "0", feminin: "0", total: "0", proportion: "0" },
        { name: "GITEGA", masculin: "47", feminin: "1", total: "48", proportion: "2,1" },
        { name: "KARUSI", masculin: "25", feminin: "2", total: "27", proportion: "1,2" },
        { name: "KIGANDA", masculin: "4", feminin: "0", total: "4", proportion: "0,2" },
        { name: "MURAMVYA", masculin: "5", feminin: "7", total: "12", proportion: "0,5" },
        { name: "MWARO", masculin: "0", feminin: "0", total: "0", proportion: "0" },
        { name: "NYABIHANGA", masculin: "0", feminin: "0", total: "0", proportion: "0" },
        { name: "SHOMBO", masculin: "0", feminin: "0", total: "0", proportion: "0" }
      ],
      masculin: "81",
      feminin: "10",
      total: "91",
      proportion: "4,0"
    }
  ],
  total: {
    masculin: "2 022",
    feminin: "229",
    total: "2 251",
    proportion: "100,0"
  }
};

const HomelessPopulationPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [expandedProvinces, setExpandedProvinces] = useState({});
  const [shareAnchorEl, setShareAnchorEl] = useState(null);
  const [downloadAnchorEl, setDownloadAnchorEl] = useState(null);
  const [openKeyStats, setOpenKeyStats] = useState(true);
  
  const handleCopyTable = () => {
    let tableContent = "Province/Commune\tMasculin\tFéminin\tTotal\tProportion (%)\n";
    
    // Ajout des données totales
    tableContent += `BURUNDI\t${homelessData.total.masculin}\t${homelessData.total.feminin}\t${homelessData.total.total}\t${homelessData.total.proportion}\n`;
    
    // Ajout des données par province et commune
    homelessData.provinces.forEach(province => {
      tableContent += `${province.name}\t${province.masculin}\t${province.feminin}\t${province.total}\t${province.proportion}\n`;
      
      province.communes.forEach(commune => {
        tableContent += `  ${commune.name}\t${commune.masculin}\t${commune.feminin}\t${commune.total}\t${commune.proportion}\n`;
      });
    });
    
    navigator.clipboard.writeText(`${homelessData.title}\n\n${tableContent}`)
      .then(() => alert('Tableau copié dans le presse-papier'))
      .catch(err => console.error('Erreur lors de la copie:', err));
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const toggleProvince = (provinceName) => {
    setExpandedProvinces(prev => ({
      ...prev,
      [provinceName]: !prev[provinceName]
    }));
  };

  const handleShareMenuOpen = (event) => {
    setShareAnchorEl(event.currentTarget);
  };

  const handleDownloadMenuOpen = (event) => {
    setDownloadAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setShareAnchorEl(null);
    setDownloadAnchorEl(null);
  };

  const shareVia = (method) => {
    handleMenuClose();
    const text = `Découvrez les données sur les sans-abris du Burundi: ${homelessData.title}`;
    const url = window.location.href;
    
    switch(method) {
      case 'whatsapp':
        window.open(`https://wa.me/?text=${encodeURIComponent(text + ' ' + url)}`, '_blank');
        break;
      case 'email':
        window.open(`mailto:?subject=${encodeURIComponent(text)}&body=${encodeURIComponent(url)}`, '_blank');
        break;
      case 'bluetooth':
        alert(`Partage via Bluetooth simulé: ${text}`);
        break;
      default:
        if (navigator.share) {
          navigator.share({
            title: text,
            url: url
          }).catch(err => console.log('Erreur de partage:', err));
        } else {
          navigator.clipboard.writeText(url);
          alert('Lien copié dans le presse-papier');
        }
    }
  };

  const downloadFile = (format) => {
    handleMenuClose();
    const blob = new Blob([JSON.stringify(homelessData, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `sans-abris-burundi.${format}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    
    alert(`Téléchargement du fichier ${format} simulé`);
  };

// Calcul des indicateurs clés
const keyStats = {
  totalPopulation: homelessData.total.total,

  womenPercentage: (
    (parseFloat(homelessData.total.feminin.replace(/\s/g, '')) / 
     parseFloat(homelessData.total.total.replace(/\s/g, ''))) * 100
  ).toFixed(1),

  mostPopulousProvince: homelessData.provinces.reduce((max, province) => 
    parseFloat(province.total.replace(/\s/g, '')) > parseFloat(max.total.replace(/\s/g, '')) ? province : max
  ),

  leastPopulousProvince: homelessData.provinces.reduce((min, province) => 
    parseFloat(province.total.replace(/\s/g, '')) < parseFloat(min.total.replace(/\s/g, '')) ? province : min
  ),

  highestWomenPercentage: homelessData.provinces.reduce((max, province) => {
    const womenPct = (
      parseFloat(province.feminin.replace(/\s/g, '')) / 
      parseFloat(province.total.replace(/\s/g, ''))
    ) * 100;
    return womenPct > max.womenPct ? { province, womenPct } : max;
  }, { province: null, womenPct: 0 }),

  highestGenderGap: homelessData.provinces.reduce((max, province) => {
    const gap = Math.abs(
      (parseFloat(province.masculin.replace(/\s/g, '')) - 
       parseFloat(province.feminin.replace(/\s/g, ''))) / 
      parseFloat(province.total.replace(/\s/g, '')) * 100
    );
    return gap > max.gap ? { province, gap } : max;
  }, { province: null, gap: 0 })
};


  const filteredProvinces = homelessData.provinces.map(province => {
    if (!searchTerm) return province;
    
    const filteredCommunes = province.communes.filter(commune =>
      commune.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    
    return {
      ...province,
      communes: filteredCommunes,
      show: filteredCommunes.length > 0 || 
            province.name.toLowerCase().includes(searchTerm.toLowerCase())
    };
  }).filter(province => province.show || !searchTerm);


  // Composant du menu latéral
  const drawer = (
    <div>
      {isMobile && (
        <MobileDrawerHeader>
          <IconButton onClick={handleDrawerToggle}>
            <Close color="primary" />
          </IconButton>
        </MobileDrawerHeader>
      )}
      <Divider />
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              component={Link}
              to={item.to}
              onClick={isMobile ? handleDrawerToggle : undefined}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  );


  return (
     <MainContainer>
      <CssBaseline />
      <NavigationBar />
      <MainContentWithDrawer>
        {!isMobile ? (
          <DrawerWrapper>
            {drawer}
          </DrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            {drawer}
          </Drawer>
        )}

        <ContentWrapper>
          <Container maxWidth="lg">
            {isMobile && (
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                <Button 
                  variant="outlined" 
                  startIcon={<MenuIcon />} 
                  onClick={handleDrawerToggle}
                  sx={{ color: primaryColor, borderColor: primaryColor }}
                >
                  Menu
                </Button>
              </Box>
            )}
            
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: { xs: 1, sm: 3 }, mb: 3, borderLeft: `4px solid ${primaryColor}` }}>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 2 }}>
                    <Typography variant="h5" component="h2" fontWeight="bold" color="primary" sx={{ mb: { xs: 1, sm: 0 } }}>
                      {homelessData.title}
                    </Typography>
                  </Box>
                     <Grid container spacing={1} style={{ marginTop: '5px',marginBottom: '5px' }}>
                        <Grid item xs={12} sm={6} md={6} ></Grid>
                        <Grid item xs={12} sm={6} md={6}>
                       <TextField
                      size="small"
                      placeholder="Rechercher province/commune..."
                      variant="outlined"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search />
                          </InputAdornment>
                        ),
                      }}
                      sx={{ width: { xs: '100%', sm: '480px' } }}
                    />
                    </Grid>
                    </Grid>

                  
                  {/* Section des indicateurs clés */}
                  <Accordion expanded={openKeyStats} onChange={() => setOpenKeyStats(!openKeyStats)} sx={{ mb: 3 }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Typography variant="subtitle1" fontWeight="bold">
                        Indicateurs Clés par Province
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Population Totale
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {homelessData.total.total}
                              </Typography>
                              <Typography variant="caption">
                                Sans-abris recensés
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Proportion Femmes
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {keyStats.womenPercentage}%
                              </Typography>
                              <Typography variant="caption">
                                Moyenne nationale
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Province la plus touchée
                              </Typography>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.mostPopulousProvince.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.mostPopulousProvince.total}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  ({keyStats.mostPopulousProvince.proportion}%)
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Plus forte proportion femmes
                              </Typography>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.highestWomenPercentage.province.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.highestWomenPercentage.womenPct.toFixed(1)}%
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                  
                  <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                    <Table size="small" aria-label="Tableau des données démographiques">
                      <StyledTableHead>
                        <TableRow>
                          <TableCell>Province/Commune</TableCell>
                          <TableCell align="right">Masculin</TableCell>
                          <TableCell align="right">Féminin</TableCell>
                          <TableCell align="right">Total</TableCell>
                          <TableCell align="right">Proportion (%)</TableCell>
                        </TableRow>
                      </StyledTableHead>
                      <TableBody>
                        {/* Ligne pour le total Burundi */}
                        <ProvinceRow hover>
                          <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>
                            BURUNDI
                          </TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{homelessData.total.masculin}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{homelessData.total.feminin}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{homelessData.total.total}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{homelessData.total.proportion}</TableCell>
                        </ProvinceRow>

                        {/* Données par province et commune */}
                        {filteredProvinces.map((province, index) => (
                          <React.Fragment key={index}>
                            <ProvinceRow 
                              hover 
                              onClick={() => toggleProvince(province.name)}
                              sx={{ cursor: 'pointer' }}
                            >
                              <TableCell component="th" scope="row">
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  {expandedProvinces[province.name] ? <ExpandLess /> : <ExpandMore />}
                                  {province.name}
                                </Box>
                              </TableCell>
                              <TableCell align="right">{province.masculin}</TableCell>
                              <TableCell align="right">{province.feminin}</TableCell>
                              <TableCell align="right">{province.total}</TableCell>
                              <TableCell align="right">{province.proportion}</TableCell>
                            </ProvinceRow>
                            
                            <TableRow>
                              <TableCell style={{ padding: 0 }} colSpan={5}>
                                <Collapse in={expandedProvinces[province.name] || !!searchTerm} timeout="auto" unmountOnExit>
                                  <Table size="small" sx={{ backgroundColor: '#fafafa' }}>
                                    <TableBody>
                                      {province.communes.map((commune, idx) => (
                                        <CommuneRow key={idx} hover>
                                          <TableCell sx={{ pl: 6 }}>{commune.name}</TableCell>
                                          <TableCell align="right">{commune.masculin}</TableCell>
                                          <TableCell align="right">{commune.feminin}</TableCell>
                                          <TableCell align="right">{commune.total}</TableCell>
                                          <TableCell align="right">{commune.proportion}</TableCell>
                                        </CommuneRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                    {/*
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Tooltip title="Copier le tableau">
                      <IconButton onClick={handleCopyTable} sx={{ color: primaryColor }}>
                        <FileCopy />
                      </IconButton>
                    </Tooltip>
                    
                    <Tooltip title="Télécharger les données">
                      <IconButton 
                        onClick={handleDownloadMenuOpen}
                        sx={{ color: secondaryColor }}
                      >
                        <Download />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={downloadAnchorEl}
                      open={Boolean(downloadAnchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => downloadFile('xlsx')}>
                        <ListItemIcon>
                          <InsertDriveFile fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Excel (.xlsx)</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => downloadFile('csv')}>
                        <ListItemIcon>
                          <Description fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>CSV (.csv)</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => downloadFile('pdf')}>
                        <ListItemIcon>
                          <PictureAsPdf fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>PDF (.pdf)</ListItemText>
                      </MenuItem>
                    </Menu>
                    
                    <Tooltip title="Partager">
                      <IconButton 
                        onClick={handleShareMenuOpen}
                        sx={{ color: primaryColor }}
                      >
                        <Share />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={shareAnchorEl}
                      open={Boolean(shareAnchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => shareVia('whatsapp')}>
                        <ListItemIcon>
                          <WhatsApp fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>WhatsApp</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('email')}>
                        <ListItemIcon>
                          <Email fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Email</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('bluetooth')}>
                        <ListItemIcon>
                          <Bluetooth fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Bluetooth</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('other')}>
                        <ListItemIcon>
                          <MoreVert fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Autre méthode</ListItemText>
                      </MenuItem>
                    </Menu>
                  </Box>
                  */}
                </Paper>
                
                {/* Section d'information */}
                <Accordion sx={{ mb: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="subtitle2" color="primary">
                      À propos des sans-abris
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2" paragraph>
                      Les sans-abris sont définis comme des personnes vivant dans des lieux non conçus pour l'habitation, tels que:
                    </Typography>
                    <List dense sx={{ py: 0 }}>
                      <ListItem>
                        <ListItemText 
                          primary="• Dans la rue ou espaces publics" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Abris de fortune" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Véhicules abandonnés" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Bâtiments inoccupés" 
                        />
                      </ListItem>
                    </List>
                    <Typography variant="body2" mt={2}>
                      Ces données représentent {homelessData.total.total} personnes sans domicile fixe au Burundi, 
                      dont seulement {keyStats.womenPercentage}% sont des femmes, montrant une forte disparité de genre.
                    </Typography>
                  </AccordionDetails>
                </Accordion>
                
                {/* Notes méthodologiques */}
                <Paper sx={{ p: 2, backgroundColor: '#f0f0f0', borderLeft: `4px solid ${secondaryColor}` }}>
                  <Typography variant="subtitle2" gutterBottom color="primary">
                    Notes méthodologiques
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Les données présentées sont issues du Recensement Général de la Population, de l'Habitat, de l'Agriculture et de l'Elevage (RGPHAE) 
                    réalisé en 2024. Le comptage des sans-abris est particulièrement difficile et ces chiffres 
                    représentent probablement une sous-estimation de la réalité. Les proportions sont calculées 
                    par rapport au total national des sans-abris recensés.
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </ContentWrapper>
      </MainContentWithDrawer>
      
      {/* Pied de page */}
      <Footer />
    </MainContainer>
  );
};

export default HomelessPopulationPage;